function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Livello 1",
    id: "Livello_1",
    viewBox: "0 0 151.57 151.57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 75.78,
    cy: 75.78,
    r: 72.28,
    style: {
      fill: "#da2244",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    },
    x1: 35.2,
    x2: 116.37,
    y1: 104.37,
    y2: 104.37
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    },
    x1: 116.37,
    x2: 75.78,
    y1: 104.37,
    y2: 35.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    },
    x1: 35.2,
    x2: 75.78,
    y1: 104.37,
    y2: 35.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    },
    x1: 75.78,
    x2: 75.78,
    y1: 57.32,
    y2: 83.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.78,
    cy: 91.63,
    r: 2.62,
    style: {
      fill: "#fcfbf2"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b604c3af11d5a9be49849a5aca131acb.svg";
export { ForwardRef as ReactComponent };